<template>
  <v-container>
    <!-- Form -->
    <v-form ref="form" class="mt-12">
      <!-- Plantilla -->
      <h1>Edició de Plantilla</h1>
      <!-- Plantilla Base -->
      <v-row>
        <v-col sm="12">
          <v-text-field v-model="plantilla.nom" label="Nom" autofocus outlined required></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="11">
          <v-autocomplete
            v-model="plantilla.producte_final"
            :items="materiesProducteFinalOpcions"
            label="Producte Final"
            item-value="id"
            item-text="nom"
            outlined
            no-data-text="No s'ha pogut carregar cap producte final"
          ></v-autocomplete>
        </v-col>
        <v-col sm="1">
          <!-- Dialog/Modal per crear materia producte final -->
          <v-dialog v-model="dialogProducteFinal" persistent max-width="600">
            <template v-slot:activator="{ on }">
              <v-btn outlined block color="success" dark v-on="on" tabindex="-1">+</v-btn>
            </template>
            <v-card>
              <v-card-title class="headline">Crear materia producte final</v-card-title>
              <v-container>
                <v-form id="formMateriaProducteFinal" ref="formMateriaProducteFinal" class="mt-12">
                  <v-row>
                    <v-col md="12">
                      <v-text-field v-model="materia_producte_final_nou.nom" label="Nom" required></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col md="12">
                      <v-text-field
                        v-model="materia_producte_final_nou.descripcio"
                        label="Descripció"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
              <v-card-actions>
                <v-btn
                  color="green darken-1"
                  text
                  @click="dialogProducteFinal = false"
                  tabindex="-1"
                >Cancel·lar</v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="green darken-1"
                  text
                  @click="btnCrearProducteFinal"
                  tabindex="-1"
                >Crear</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- ./Dialog/Modal per crear materia producte final -->
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="12">
          <v-text-field v-model="plantilla.observacions" outlined label="Observacions" required></v-text-field>
        </v-col>
      </v-row>
      <!-- ./Plantilla Base -->
      <!-- Percentatges -->
      <v-row>
        <v-col sm="2" offset-sm="10">
          <v-btn color="info" @click="afegirPercentatge()" tabindex="-1">Afegir Ingredient</v-btn>
        </v-col>
      </v-row>
      <v-row v-for="(item, index) in plantilla.percentatges" :key="index" id="ingredients">
        <v-col sm="2" offset-sm="0">
          <v-text-field
            v-model="item.percentatge"
            label="Percentatge"
            @input="editarPercentatge(index, item)"
            required
            outlined
          ></v-text-field>
        </v-col>
        <v-col sm="4" offset-sm="0">
          <v-autocomplete
            v-model="item.ingredient"
            :items="ingredientsOpcions"
            label="Ingredients"
            item-value="id"
            item-text="nom"
            @input="editarPercentatge(index, item)"
            outlined
            no-data-text="No s'ha pogut carregar cap ingredient"
          />
        </v-col>
        <v-col sm="2" offset-sm="1">
          <v-btn
            outlined
            block
            color="success"
            dark
            @click="btnCrearIngredientModal(index)"
            tabindex="-1"
          >+</v-btn>
        </v-col>
        <v-col sm="2" offset-sm="1">
          <v-btn
            color="error"
            @click="eliminaPercentatge(index, item.id)"
            tabindex="-1"
          >Eliminar </v-btn>
        </v-col>
      </v-row>
      <!-- ./Percentatges -->
      <!-- ./Plantilla -->
      <div id="botonera">
        <v-btn color="error" @click="cancelarEdicio" tabindex="-1">Cancel·lar edició</v-btn>
        <v-btn
          color="success"
          @click="editarPlantilla"
          :disabled="comprovadorPercentatge"
        >Guardar canvis</v-btn>
      </div>
    </v-form>
    <!-- Form -->
    <!-- Footer -->
    <v-footer class="font-weight-medium" height="38%">
      <v-col class="text-center" cols="12" @click="redireccio('PlantillaDetail')" style="padding:0px">
        <span>Gestió Integral Borreres, {{ new Date().getFullYear() }}</span>
      </v-col>
    </v-footer>
    <!-- ./Footer -->
    <!-- Dialog/Modal per crear ingredients -->
    <v-dialog v-model="dialogIngredient" persistent max-width="600">
      <v-card>
        <v-card-title class="headline">Crear tipus de materia</v-card-title>
        <v-container>
          <v-form id="formIngredient" ref="formIngredient" class="mt-12">
            <v-row>
              <v-col md="12">
                <v-text-field v-model="ingredient_nou.nom" label="Nom" required autofocus  @keydown.enter.prevent="btnCrearIngredient"></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
        <v-card-actions>
          <v-btn
            color="green darken-1"
            text
            @click="dialogIngredient = false"
            tabindex="-1"
          >Cancel·lar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="btnCrearIngredient">Crear</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ./Dialog/Modal per crear ingredients -->
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { EventBus } from "@/event-bus.js";

export default {
  name: "plantilla-edit",
  data: () => ({
    plantilla: {
      id: null,
      nom: "",
      observacions: "",
      percentatges: [
        { id: null, ingredient: null, percentatge: 0, plantilla: null }
      ],
      producte_final: null
    },
    dialogIngredient: false,
    dialogProducteFinal: false,
    nouIngredientIndex: null,
    ingredient_nou: {
      nom: ""
    },
    materia_producte_final_nou: {
      nom: "",
      descripcio: ""
    }
  }),
  computed: {
    ...mapGetters({
      ingredientsOpcions: "getIngredients",
      materiesProducteFinalOpcions: "getMateriesProducteFinal"
    }),

    comprovadorPercentatge() {
      // Comprovem que la suma de tots els percentatges siga 100
      let total = 0;
      const percentatges = this.plantilla.percentatges.map(
        el => el.percentatge
      );

      // Comprovem que cap percentatge siga un 0
      if (percentatges.includes(0)) return true;

      // Comprovem que la suma de tots els percentatges siga 100
      percentatges.forEach(el => {
        if (!isNaN(parseFloat(el))) total += parseFloat(el);
      });

      if (total != 100) return true;

      // Comprovem que els materials siguen diferents i no tinguen cap element null
      const ingredients = this.plantilla.percentatges.map(el => el.ingredient);
      if (
        ingredients.length != new Set(ingredients).size ||
        ingredients.includes(null)
      )
        return true;
      return false;
    }
  },
  methods: {
    ...mapActions([
      "editPercentatgeMesclat",
      "editPlantilla",
      "eliminarPercentatgeMesclat",
      "getIngredients",
      "getMateriesProducteFinal",
      "getPlantilla",
      "sendIngredient",
      "sendMateriaProducteFinal",
      "sendPercentatgeMesclat"
    ]),

    editarPlantilla() {
      this.editPlantilla(this.plantilla).then(response => {
        if (response === 200) {
          EventBus.$emit("Plantilla.Notificacio", {
            text: "Plantilla editada correctament",
            color: "success"
          });

          this.$router.push({
            name: "PlantillaDetail",
            params: { id: this.plantilla.id }
          });
        } else
          EventBus.$emit("Entrada.Notificacio", {
            text: "Error editant l'entrada",
            color: "error"
          });
      });
    },
    // Percentatges
    afegirPercentatge() {
      this.plantilla.percentatges.push({
        ingredient: null,
        percentatge: 0,
        plantilla: this.plantilla.id,
        percentatge_nou: true
      });
    },
    btnCrearIngredient() {
      this.sendIngredient(this.ingredient_nou).then(data => {
        if (data?.status === 201) {
          this.ingredient_nou = {
            nom: ""
          };
          this.dialogIngredient = false;
          this.plantilla.percentatges[this.nouIngredientIndex].ingredient =
            data.data.id;
        }
      });
    },
    btnCrearProducteFinal() {
      this.sendMateriaProducteFinal(this.materia_producte_final_nou).then(
        data => {
          if (data?.status === 201) {
            this.materia_producte_final_nou = {
              nom: "",
              descripcio: ""
            };
            this.dialogProducteFinal = false;
            this.plantilla.producte_final = data.data.id;
          }
        }
      );
    },
    btnCrearIngredientModal(index) {
      this.dialogIngredient = true;
      this.nouIngredientIndex = index;
    },
    eliminaPercentatge(index) {
      if (this.plantilla.percentatges.length > 1) {
        this.plantilla.percentatges.splice(index, 1);
      }
    },
    editarPercentatge(index, item) {
      if (item.percentatge <= 0) {
        this.$nextTick(() => {
          this.plantilla.percentatges[index].percentatge = 0;
        });
      }
      if (item.percentatge >= 100) {
        this.$nextTick(() => {
          this.plantilla.percentatges[index].percentatge = 100;
        });
      }
    },
    // Auxiliar
    cancelarEdicio() {
      this.$router.push({
        name: "PlantillaDetail",
        params: { id: this.$route.params.id }
      });
    },
    redireccio(component) {
      this.$router.push({ name: component, params: { id: this.plantilla.id } });
    }
  },
  created() {
    this.getPlantilla(this.$route.params.id).then(
      plantilla => (this.plantilla = plantilla)
    );
    this.getIngredients();
    this.getMateriesProducteFinal();
  }
};
</script>

<style lang="scss" scoped>
h1 {
  text-align: center;
  padding-bottom: 1em;
}
h2 {
  text-align: center;
  padding-bottom: 0.5em;
}
#botonera-bala {
  padding-top: 1em;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  button {
    width: 45%;
  }
}
#botonera {
  padding-bottom: 50px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  button {
    width: 45%;
  }
}
#ingredients {
  border: grey solid 1px;
  border-radius: 15px;
  margin-bottom: 15px;
}
</style>